import script from "./PostDisbursementChangeForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./PostDisbursementChangeForm.vue?vue&type=script&setup=true&lang=ts"

import "./PostDisbursementChangeForm.vue?vue&type=style&index=0&id=48171986&scoped=true&lang=css"
import "@/assets/css/certifications/certification-form.css?vue&type=style&index=1&id=48171986&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48171986"]])

export default __exports__